import { useApp } from '@/store/useApp';

export function VersionHistory() {
  const versions = useApp((s) => s.versions);
  const selectedId = useApp((s) => s.selectedVersionId);
  const select = useApp((s) => s.selectVersion);
  const revert = useApp((s) => s.revertToVersion);

  if (versions.length === 0) return null;

  const isLatest = versions[versions.length - 1]?.id === selectedId;

  return (
    <div className="flex items-center gap-2">
      <select
        value={selectedId ?? ''}
        onChange={(e) => void select(e.target.value)}
        className="rounded-md border border-neutral-300 bg-white px-2 py-1 text-xs dark:border-neutral-700 dark:bg-neutral-900"
        aria-label="Version"
      >
        {versions.map((v, i) => (
          <option key={v.id} value={v.id}>
            v{i + 1} · {v.status}
          </option>
        ))}
      </select>
      {!isLatest && selectedId && (
        <button
          type="button"
          onClick={() => void revert(selectedId)}
          className="rounded-md px-2 py-1 text-[11px] text-neutral-500 hover:bg-neutral-100 dark:hover:bg-neutral-800"
        >
          Revert as new
        </button>
      )}
    </div>
  );
}
